<template lang="html">

  <section class="lien-voir-plus">
    <div class="container-fluid">
      <div class="text-right more">
          <router-link :to="lien">
            {{message}}
            <i class="fa fa-angle-right" aria-hidden="true"></i> 
          </router-link>
          <hr>
      </div>
    </div>
  </section>

</template>

<script lang="js">
  export default  {
    name: 'lien-voir-plus',
    props: [
      'message',
      'lien'
    ],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

